export default __webpack_public_path__ + "static/img5-f90d6d3017167127bb846c6bf7802728.png";